import { JSX } from "react";
import ControlledForm from "../Components/ControlledForm";
import { CommonFormSwitchType } from "../DataTypes/Common";
import { CheckStringEmpty } from "./Common";
import ImgPath from "Constants/Imgs";
export const commonFormSwitch = (props: CommonFormSwitchType) => {
  const { formObj: data, onChange: handleChange } = props;
  const inputProps = {
    id: data.id,
    label: data.label,
    placeholder: data.placeholder,
    type: data.hasPasswordToggle && data.showPassword ? "text" : data.type,
    value: typeof data.value == "string" ? data.value : "",
    error: data.error,
    errorText: data.errorText,
    required: data.required,
    multiline: data.multiline,
    multilineRows: data.multilineRows,
    readOnly: data.readOnly,
    infoText: data.infoText,
    VerifyLinkLabel: data?.VerifyLinkLabel,
    showVerifyLink: data?.showVerifyLink,
    showVerificationInput: data?.showVerificationInput,
    handleVerifyLink: data?.handleVerifyLink,
    handleLinkSubmit: data?.handleLinkSubmit,
    hasPasswordToggle: data.hasPasswordToggle,
    showPassword: data.showPassword,
    onPasswordToggle: data.onPasswordToggle,
  };

  const singledropArrProp = {
    id: data.id,
    label: data.label,
    placeholder: data.placeholder,
    dropArr: data.dropArr ? data.dropArr : [],
    error: data.error,
    errorText: data.errorText,
    required: data.required,
    dropValue:
      typeof data?.dropValue == "string" || typeof data?.dropValue == "number"
        ? data?.dropValue
        : "",
    onClick: (value: string | number) => {
      handleChange && handleChange({ value: value, id: data?.id });
    },
    readOnly: data.readOnly,
  };

  const multidropArrProp = {
    id: data.id,
    label: data.label,
    placeholder: data.placeholder,
    dropArr: data.dropArr ? data.dropArr : [],
    error: data.error,
    errorText: data.errorText,
    required: data.required,
    dropValue: Array.isArray(data?.dropValue) ? data?.dropValue : [],
    onClick: (value: (string | number)[]) => {
      handleChange && handleChange({ value: value, id: data?.id });
    },
    readOnly: data.readOnly,
    disableSelectAll: data.disableSelectAll,
    disableArr: data.disableArr,
  };

  const dateTimeProps = {
    id: data?.id,
    label: data?.label,
    placeholder: data?.placeholder,
    type: data?.type,
    error: data?.error,
    errorText: data?.errorText,
    required: data?.required,
    readOnly: data?.readOnly,
    value: CheckStringEmpty(data?.value),
    minVal: data?.minVal,
    maxVal: data?.maxVal,
  };

  // // NEW: Autocomplete Props
  // const autocompleteProps = {
  //   id: data.id,
  //   label: data.label,
  //   placeholder: data.placeholder,
  //   options: data.dropArr ? data.dropArr : [], // MUI Autocomplete uses 'options'
  //   value: data.value || null, // Should be null or the option object/string
  //   error: data.error,
  //   errorText: data.errorText,
  //   required: data.required,
  //   readOnly: data.readOnly,
  //   freeSolo: true, // This allows typing new organization names
  // };

  switch (data.boxType) {
    case "input-box":
      return (
        <ControlledForm.Input
          {...inputProps}
          {...(handleChange && {
            onChange: (value) =>
              handleChange({
                value: typeof value == "string" ? value : "",
                id: data.id,
              }),
          })}
        />
      );

    case "autocomplete":
      return (
        <ControlledForm.Autocomplete
          id={data.id}
          label={data.label}
          placeholder={data.placeholder}
          dropArr={data.dropArr || []}
          // Use type casting and fallback to empty string
          value={(data.value as string | number) ?? ""}
          required={data.required}
          error={data.error}
          errorText={data.errorText}
          readOnly={data.readOnly}
          onChange={(val: any) => {
            handleChange && handleChange({
              value: val,
              id: data.id,
            });
          }}
        />
      );

    case "single-select-drop":
      return <ControlledForm.SingleSelectDrop {...singledropArrProp} />;
    case "multi-select-drop":
      return <ControlledForm.MultiSelectDrop {...multidropArrProp} />;
    case "mui-date":
      return (
        <ControlledForm.MuiDatePicker
          {...dateTimeProps}
          {...(handleChange && {
            onChange: (value) =>
              handleChange({
                value: CheckStringEmpty(value),
                id: data.id,
              }),
          })}
        />
      );
    case "mui-time":
      return (
        <ControlledForm.MuiTimePicker
          {...dateTimeProps}
          {...(handleChange && {
            onChange: (value) =>
              handleChange({
                value: CheckStringEmpty(value),
                id: data.id,
              }),
          })}
        />
      );
    case "date-time":
      return (
        <ControlledForm.DateTimePicker
          {...dateTimeProps}
          {...(handleChange && {
            onChange: (value) =>
              handleChange({
                value: CheckStringEmpty(value),
                id: data.id,
              }),
          })}
        />
      );
    default:
      return <ControlledForm.Input {...inputProps} />;
  }
};

export const ControlledBoxSizeSwitch: (size?: number) => {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
} = (size) => {
  switch (size || 12) {
    case 2:
      return { xs: 12, sm: 6, md: 2, lg: 2, xl: 1.5 }; // four in a row
    case 3:
      return { xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }; // four in a row
    case 4:
      return { xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }; // three in a row
    case 6:
      return { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }; // two in a row
    case 12:
      return { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }; // full width
    default:
      return { xs: 12, sm: 6, md: 3, lg: 3, xl: 3 };
  }
};

export const InputImgSwitch: (iconId: string) => JSX.Element = (iconId) => {
  switch (iconId) {
    case "password-icon":
      return <ImgPath.LockIcon color="primary" />;
    case "search":
      return <ImgPath.SearchIcon color="primary" />;
    case "check-icon":
      // return <ImgPath.CheckIcon color="success" />;
      return <ImgPath.checkIcon color="success" />;
    default:
      return <></>;
  }
};
